import { useEffect, useState } from "react";

const HERO_IMAGES = [
  "https://images.unsplash.com/photo-1638454668466-e8dbd5462f20?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxjb3p5JTIwYXBhcnRtZW50JTIwYmVkcm9vbSUyMHdvb2RlbiUyMGZ1cm5pdHVyZSUyMHdpbmRvdyUyMGJyaWdodCUyMG1pbmltYWx8ZW58MHx8fHwxNzkxMTUyMDE0fDA&ixlib=rb-4.1.0&q=85&w=1200",
  "https://images.unsplash.com/photo-1556020685-ae41abfc9365?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxjb3p5JTIwYXBhcnRtZW50JTIwYmVkcm9vbSUyMG1pbmltYWwlMjBicmlnaHR8ZW58MHx8fHwxNzkyMzAwNTM5fDA&ixlib=rb-4.1.0&q=85&w=1200",
  "https://images.unsplash.com/photo-1789381500057-2a288d79e9e6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHw0fHxjb3p5JTIwYXBhcnRtZW50JTIwYmVkcm9vbSUyMG1pbmltYWwlMjBicmlnaHR8ZW58MHx8fHwxNzkyMzAwNTM5fDA&ixlib=rb-4.1.0&q=85&w=1200",
  "https://images.unsplash.com/photo-1543490791-db8323d8e5b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxjb3p5JTIwYXBhcnRtZW50JTIwYmVkcm9vbSUyMG1pbmltYWwlMjBicmlnaHR8ZW58MHx8fHwxNzkyMzAwNTM5fDA&ixlib=rb-4.1.0&q=85&w=1200",
];

export function HeroSlideshow() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % HERO_IMAGES.length), 2000);
    return () => clearInterval(t);
  }, [idx]);
  return (
    <div className="relative w-full h-[280px] sm:h-[480px] lg:h-[560px] rounded-2xl sm:rounded-[2rem] overflow-hidden shadow-2xl shadow-slate-900/15"
         data-testid="hero-image">
      {HERO_IMAGES.map((src, i) => (
        <img key={src} src={src} alt="PG room at StayCare"
             className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${
               i === idx ? "opacity-100" : "opacity-0"
             }`} />
      ))}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-1.5" data-testid="hero-slideshow-dots">
        {HERO_IMAGES.map((src, i) => (
          <button key={`dot-${src}`} onClick={() => setIdx(i)} aria-label={`Slide ${i + 1}`}
                  data-testid={`hero-dot-${i}`}
                  className={`h-1.5 rounded-full transition-all duration-300 ${
                    i === idx ? "w-6 bg-white" : "w-1.5 bg-white/50 hover:bg-white/80"
                  }`} />
        ))}
      </div>
    </div>
  );
}
